import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNV02 from '../actions/actionTypesNV02';
import { fetchLavaMetricsSaga } from './NV02.saga';

export function* watchFetchProductMetricsSaga() {
  yield takeLatest(actionTypesNV02.WAREHOUSE_METRICS_GET, fetchLavaMetricsSaga);
  yield takeLatest(actionTypesNV02.PRODUCT_METRICS_GET, fetchLavaMetricsSaga);
  yield takeLatest(actionTypesNV02.PRODUCT_BY_GROUP_GET, fetchLavaMetricsSaga);
  yield takeLatest(actionTypesNV02.LAGERKODE_GET, fetchLavaMetricsSaga);
}
